import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import api from "../../../helper/api";
import { toast } from "react-toastify";

export const createCommission = createAsyncThunk("user/createCommission", async (payload) => {

  const response = await api.post("admin/commission/create", payload);
 
  return response.data;
});

const createCommissionSlice = createSlice({
  name: "user",
  initialState: {
    data:null,
    loading: false,
    error: null,
  },
  middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: {
      ignoredPaths: ["payload.headers"],
    },
  }),
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createCommission.pending, (state) => {
        state.loading = true;
      })
      .addCase(createCommission.fulfilled, (state, action) => {
   
        state.loading = false;
        state.data = action.payload;
        toast.success(action.payload.message);
      })
      .addCase(createCommission.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
        toast.error(action.error.message);
      });
  },
});

export default createCommissionSlice.reducer;
